// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// Components
import EmptyTable from "./components/EmptyTable";
import TableFooter from "./components/TableFooter";
import TableHead from "./components/TableHead";
import TableHeader from "./components/TableHeader";
import TableRow from "./components/TableRow";
import Toolbar from "./components/Toolbar";

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      orderBy: undefined,
      pageSize: 10,
      sort: undefined,
      trainingProvider: `all`
    };
  }

  handleColumnNameClick = (columnKey) => (e) => {
    e.stopPropagation();
    const { handleColumnNameClick } = this.props;
    const { lastSearch, lastTrainingProvider } = this.state;
    this.setState(
      (prevState) => ({
        currentPage: 1,
        orderBy: columnKey,
        sort: !(prevState.orderBy === columnKey) ? `asc` : prevState.sort === `asc` ? `desc` : `asc`
      }),
      () =>
        handleColumnNameClick({
          offset: 0,
          // eslint-disable-next-line react/destructuring-assignment
          orderBy: this.state.orderBy,
          // eslint-disable-next-line react/destructuring-assignment
          pageSize: this.state.pageSize,
          // eslint-disable-next-line react/destructuring-assignment
          sort: this.state.sort,
          q: lastSearch,
          trainingProvider: lastTrainingProvider
        })
    );
  };

  isNextButtonEnabled = () => {
    const { totalResults } = this.props;
    const { currentPage, pageSize } = this.state;

    const maxPages = Math.ceil(totalResults / pageSize);
    return currentPage < maxPages;
  };

  isBackButtonEnabled = () => {
    const { currentPage } = this.state;
    return currentPage > 1;
  };

  onPageSizeChange = (e) => {
    const { handleSearch } = this.props;
    const { lastSearch, lastTrainingProvider } = this.state;

    this.setState(
      {
        currentPage: 1,
        pageSize: e.target.value - 0
      },
      () =>
        handleSearch({
          offset: 0,
          // eslint-disable-next-line react/destructuring-assignment
          orderBy: this.state.orderBy,
          // eslint-disable-next-line react/destructuring-assignment
          pageSize: this.state.pageSize,
          // eslint-disable-next-line react/destructuring-assignment
          sort: this.state.sort,
          q: lastSearch,
          trainingProvider: lastTrainingProvider
        })
    );
  };

  onPreviousButtonClick = () => {
    if (this.isBackButtonEnabled()) {
      this.setState((prevState) => ({
        currentPage: prevState.currentPage - 1
      }));
    }
  };

  onNextButtonClick = () => {
    const { requestNextPage, rows } = this.props;
    const { currentPage, pageSize, lastTrainingProvider, lastSearch } = this.state;

    if (this.isNextButtonEnabled()) {
      this.setState(
        (prevState) => ({
          currentPage: prevState.currentPage + 1
        }),
        () => {
          if (
            // eslint-disable-next-line react/destructuring-assignment
            this.state.currentPage * this.state.pageSize >
            rows.length
          ) {
            return requestNextPage({
              offset: currentPage * pageSize,
              // eslint-disable-next-line react/destructuring-assignment
              orderBy: this.state.orderBy,
              pageSize,
              // eslint-disable-next-line react/destructuring-assignment
              sort: this.state.sort,
              q: lastSearch,
              trainingProvider: lastTrainingProvider
            });
          }
        }
      );
    }
  };

  handleSearch = (event) => {
    const { handleSearch } = this.props;
    const { pageSize, sort, orderBy, lastTrainingProvider } = this.state;
    const q = event.target.value;

    this.setState({ currentPage: 1, lastSearch: q }, () =>
      handleSearch({
        q,
        offset: 0,
        pageSize,
        sort,
        orderBy,
        trainingProvider: lastTrainingProvider
      })
    );
  };

  handleChangeTrainingProvider = (event) => {
    const { handleChangeTrainingProvider } = this.props;
    const { pageSize, sort, orderBy, lastSearch } = this.state;
    const trainingProvider = event.target.value;

    this.setState(
      {
        currentPage: 1,
        trainingProvider,
        lastTrainingProvider: trainingProvider
      },
      () => {
        handleChangeTrainingProvider({
          ...(trainingProvider !== `all` && { trainingProvider }),
          q: lastSearch,
          offset: 0,
          pageSize,
          sort,
          orderBy
        });
      }
    );
  };

  render() {
    const {
      claims,
      columns,
      emptyTableMessage,
      handleRowClick,
      isLoading,
      rows,
      tableStyle,
      title,
      totalResults,
      trainingProvidersList
    } = this.props;
    const { currentPage, mobileDevice, orderBy, pageSize, sort, trainingProvider } = this.state;

    return (
      <div
        className="jarviswidget jarviswidget-color-darken jarviswidget-sortable"
        id="wid-id-0"
        style={tableStyle}
      >
        <TableHeader title={title} />
        <div>
          <div className="widget-body no-padding">
            <div
              className="dataTables_wrapper form-inline dt-bootstrap no-footer"
              id="dt_basic_wrapper"
            >
              <Toolbar
                handleSearch={this.handleSearch}
                onPageSizeChange={this.onPageSizeChange}
                handleChangeTrainingProvider={this.handleChangeTrainingProvider}
                trainingProviders={trainingProvidersList}
                defaultValue={trainingProvider}
              />
              <table
                aria-describedby="dt_basic_info"
                className="table table-striped table-bordered table-hover dataTable no-footer"
                id="dt_basic"
                role="grid"
                style={{ width: `100%` }}
                width="100%"
              >
                <TableHead
                  columnsNames={columns}
                  onClick={this.handleColumnNameClick}
                  orderBy={orderBy}
                  sort={sort}
                />
                <tbody>
                  <EmptyTable
                    colspan={columns.length}
                    emptyMessage={emptyTableMessage}
                    isLoading={isLoading}
                    noData={!rows.length}
                  />
                  {rows.slice((currentPage - 1) * pageSize, currentPage * pageSize).map((row) => (
                    <TableRow
                      handleClick={handleRowClick}
                      key={row.id}
                      row={row}
                      mobileDevice={mobileDevice}
                      claims={claims}
                    />
                  ))}
                </tbody>
              </table>
              <TableFooter
                currentPage={currentPage}
                isBackButtonEnabled={this.isBackButtonEnabled()}
                isNextButtonEnabled={this.isNextButtonEnabled()}
                onNextButtonClick={this.onNextButtonClick}
                onPreviousButtonClick={this.onPreviousButtonClick}
                pageSize={pageSize}
                totalRows={totalResults}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Table.defaultProps = {
  title: ``
};

Table.propTypes = {
  claims: PropTypes.array.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  emptyTableMessage: PropTypes.string,
  handleChangeTrainingProvider: PropTypes.func,
  handleColumnNameClick: PropTypes.func,
  handleRowClick: PropTypes.func,
  handleSearch: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  requestNextPage: PropTypes.func.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  tableStyle: PropTypes.object,
  title: PropTypes.string,
  totalResults: PropTypes.number.isRequired,
  trainingProvidersList: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Table;
